module.exports = __webpack_public_path__ + "static/media/linux.2bf747f0.svg";